import React from "react";
/**
 * Component for rendering icons with sorting functionality.
 * Displays two arrows for sorting (ascending and descending) in vertical layout.
 * Sorting behavior is handled natively by TanStack, with sorting types defined in table.tsx.
 *
 * TanStack-Filters are defined in Table.
 *
 * @param column TanStack TanStack column variable
 */
const iconFont = " fs-4 font-dim-gray ";
const noMarginPadding = " my-0 p-0 ";
const SortIcons = ({
  columnIndex,
  header,
  table,
  currentActiveSortingColumn,
  setCurrentActiveSortingColumn,
}) => {
  const tableId: string = table.options.meta.tableId
    ? table.options.meta.tableId + "-"
    : "";
  //check the client-side sorting
  const sortField = header.column.columnDef.meta?.sortField;
  const onSortChange = header.column.columnDef.meta?.onSortChange;
  const isServerSorting = !!(sortField && onSortChange);
  const clearServerSort = header.column.columnDef.meta?.clearServerSort;

  /**
   * Set sorting state to descending for the current column
   */
  function sortIconsDesc() {
    const downArrow = document.getElementById(
      `${tableId}down-column_${columnIndex}`,
    );
    const upArrow = document.getElementById(
      `${tableId}up-column_${columnIndex}`,
    );
    if (upArrow) upArrow.style.visibility = "visible";
    if (downArrow) downArrow.style.visibility = "hidden";

    // update currentActiveSortingColumnNum to new column
    setCurrentActiveSortingColumn(columnIndex);
    if (isServerSorting) {
      // clear local sorting before server sorting
      table.setSorting([]);
      onSortChange(sortField, "DESC");
    } else {
      //clear server sorting before local sorting
      if (clearServerSort) clearServerSort();
      table.setSorting([{ id: header.column.id, desc: true }]); // Descending sort
    }
  }
  /**
   * Set sorting state to ascending for the current column
   */
  function sortIconsAsc() {
    // Set sorting state for the current column
    const downArrow = document.getElementById(
      `${tableId}down-column_${columnIndex}`,
    );
    const upArrow = document.getElementById(
      `${tableId}up-column_${columnIndex}`,
    );
    if (upArrow) upArrow.style.visibility = "hidden";
    if (downArrow) downArrow.style.visibility = "visible";

    // update currentActiveSortingColumnNum to new column
    setCurrentActiveSortingColumn(columnIndex);
    if (isServerSorting) {
      // clear local sorting before server sorting
      table.setSorting([]);
      onSortChange(sortField, "ASC");
    } else {
      //clear server sorting before local sorting
      if (clearServerSort) clearServerSort();
      table.setSorting([{ id: header.column.id, desc: false }]); // Ascending sort
    }
  }
  /**
   * Reset previous sorted column's icon state
   */
  function resetSortIcons() {
    if (currentActiveSortingColumn > 0) {
      const downArrow = document.getElementById(
        `${tableId}down-column_${currentActiveSortingColumn}`,
      );
      const upArrow = document.getElementById(
        `${tableId}up-column_${currentActiveSortingColumn}`,
      );
      if (upArrow) upArrow.style.visibility = "visible";
      if (downArrow) downArrow.style.visibility = "visible";
    }
  }
  return (
    <span className="d-flex flex-column align-items-center">
      <span
        id={`${tableId}up-column_${columnIndex}`}
        role="button"
        tabIndex={0}
        aria-label="Aufsteigend sortieren"
        className={"material-symbols-rounded" + noMarginPadding + iconFont}
        style={{ lineHeight: 0.5 }}
        onClick={() => {
          resetSortIcons();
          sortIconsAsc();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            resetSortIcons();
            sortIconsAsc();
          }
        }}
      >
        arrow_drop_up
      </span>
      <span
        id={`${tableId}down-column_${columnIndex}`}
        role="button"
        tabIndex={0}
        aria-label="Absteigend sortieren"
        className={"material-symbols-rounded" + noMarginPadding + iconFont}
        style={{ lineHeight: 0.5 }}
        onClick={() => {
          resetSortIcons();
          sortIconsDesc();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            resetSortIcons();
            sortIconsDesc();
          }
        }}
      >
        arrow_drop_down
      </span>
    </span>
  );
};
export default SortIcons;
